// @ts-nocheck
import { httpClient } from '../../../core/network';

class TapsService {
  static fetchTaps(userId) {
    const apiUrl = `/customers/${userId}/consents`;
    return httpClient.get(apiUrl);
  }

  static clearTaps(userId, taps) {
    const apiUrl = `/customers/${userId}/consent/${taps}`;
    return httpClient.delete(apiUrl);
  }
}

export default TapsService;
